import { render, staticRenderFns } from "./ConfirmationDeleteModal.vue?vue&type=template&id=00667c24&"
import script from "./ConfirmationDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports